import styled from 'styled-components'
import { H4, H5 } from '@components/Heading'
import { up } from 'styled-breakpoints'
import TeamMember from './TeamMember'

const StyledTeam = styled.div`
  text-align: center;

  h2 {
    margin-bottom: 10.2rem;
  }
`

const StyledGridContainer = styled.div`
  display: grid;
  gap: 2.4rem;
  margin-bottom: 7.2rem;
`

const StyledGrid = styled.div<{ cols?: number }>`
  display: grid;
  justify-content: center;
  column-gap: 11.2rem;
  row-gap: 3.2rem;
  grid-template-columns: 1fr;

  ${up('lg')} {
    grid-template-columns: repeat(${({ cols }) => cols || 2}, 24rem);
  }

  ${up('xl')} {
    grid-template-columns: repeat(${({ cols }) => cols || 2}, 32rem);
  }
`

const Team = () => (
  <StyledTeam>
    <H4 as="h2">Our team</H4>
    <StyledGridContainer>
      <H5 as="h3">SEO department</H5>

      <StyledGrid cols={2}>
        <TeamMember
          imageUrl="images/team/avatars/damian.jpg"
          name="Damian"
          position="Head of SEO"
        />
        <TeamMember
          imageUrl="images/team/avatars/marta-bys.jpg"
          name="Marta"
          position="Copy Team Leader"
        />
      </StyledGrid>
      <StyledGrid cols={3}>
        <TeamMember
          imageUrl="images/team/avatars/andrzej.jpg"
          name="Andrzej"
          position="Sales & Partnership Manager"
        />
        <TeamMember
          imageUrl="images/team/avatars/adrian-p.jpg"
          name="Adrian"
          position="SEO specialist"
        />
        <TeamMember
          imageUrl="images/team/avatars/darek.jpg"
          name="Darek"
          position="SEO specialist"
        />
      </StyledGrid>
      <StyledGrid cols={2}>
        <TeamMember
          imageUrl="images/team/avatars/artur.jpg"
          name="Artur"
          position="SEO specialist"
        />
        <TeamMember
          imageUrl="images/team/avatars/mikolaj.jpg"
          name="Mikołaj"
          position="Technical SEO specialist"
        />
      </StyledGrid>
      <StyledGrid cols={3}>
        <TeamMember
          imageUrl="images/team/avatars/aneta.jpg"
          name="Aneta"
          position="SEO specialist"
        />
        <TeamMember
          imageUrl="images/team/avatars/ewelina.jpg"
          name="Ewelina"
          position="E-marketing specialist"
        />
        <TeamMember
          imageUrl="images/team/avatars/magda.jpg"
          name="Magda"
          position="SEO specialist"
        />
      </StyledGrid>
      <StyledGrid cols={2}>
        <TeamMember
          imageUrl="images/team/avatars/martyna.jpg"
          name="Martyna"
          position="Copywriter"
        />
        <TeamMember
          imageUrl="images/team/avatars/beata-c.jpg"
          name="Beata"
          position="Copywriter"
        />
      </StyledGrid>
      <StyledGrid cols={3}>
        <TeamMember
          imageUrl="images/team/avatars/zuza-o.jpg"
          name="Zuza"
          position="Copywriter"
        />
        <TeamMember
          imageUrl="images/team/avatars/woman.jpg"
          name="You?"
          position=""
        />
      </StyledGrid>
    </StyledGridContainer>
    <StyledGridContainer>
      <H5 as="h3">Development department</H5>

      <StyledGrid cols={2}>
        <TeamMember
          imageUrl="images/team/avatars/aga.jpg"
          name="Aga"
          position="Head of Delivery"
        />
        <TeamMember
          imageUrl="images/team/avatars/sebastian-s.jpg"
          name="Sebastian"
          position="Team Leader / Front-end developer"
        />
      </StyledGrid>

      <StyledGrid cols={3}>
        <TeamMember
          imageUrl="images/team/avatars/ania-t.jpg"
          name="Ania"
          position="Project manager"
        />
        <TeamMember
          imageUrl="images/team/avatars/adrian-w.jpg"
          name="Adrian"
          position="Front-end developer"
        />
        <TeamMember
          imageUrl="images/team/avatars/konrad-s.jpg"
          name="Konrad"
          position="Front-end developer"
        />
      </StyledGrid>

      <StyledGrid cols={2}>
        <TeamMember
          imageUrl="images/team/avatars/mateusz-w.jpg"
          name="Mateusz"
          position="Back-end developer"
        />
        <TeamMember
          imageUrl="images/team/avatars/justyna-k.jpg"
          name="Justyna"
          position="Front-end developer"
        />
      </StyledGrid>

      <StyledGrid cols={3}>
        <TeamMember
          imageUrl="images/team/avatars/jakub-k.jpg"
          name="Jakub"
          position="Front-end developer"
        />
        <TeamMember
          imageUrl="images/team/avatars/nina.jpg"
          name="Nina"
          position="Front-end developer"
        />
        <TeamMember
          imageUrl="images/team/avatars/mateusz-w.jpg"
          name="Mateusz"
          position="Back-end developer"
        />
      </StyledGrid>

      <StyledGrid cols={2}>
        <TeamMember
          imageUrl="images/team/avatars/emil.jpg"
          name="Emil"
          position="Back-end developer"
        />
        <TeamMember
          imageUrl="images/team/avatars/robert.jpg"
          name="Robert"
          position="UI/UX designer"
        />
      </StyledGrid>
      <StyledGrid cols={3}>
        <TeamMember
          imageUrl="images/team/avatars/mikolaj-n.jpg"
          name="Mikołaj"
          position="UI/UX designer"
        />
        <TeamMember
          imageUrl="images/team/avatars/man.jpg"
          name="You?"
          position=""
        />
      </StyledGrid>
    </StyledGridContainer>
    <StyledGridContainer>
      <H5 as="h3">Administration & PR</H5>

      <StyledGrid cols={2}>
        <TeamMember
          imageUrl="images/team/avatars/agata.jpg"
          name="Agata"
          position="Office manager / Board assistant"
        />
        <TeamMember
          imageUrl="images/team/avatars/jadzia.jpg"
          name="Jadwiga"
          position="Content Manager"
        />
      </StyledGrid>
    </StyledGridContainer>
    <StyledGridContainer>
      <H5 as="h3">Management</H5>

      <StyledGrid cols={2}>
        <TeamMember
          imageUrl="images/team/avatars/tomek.jpg"
          name="Tomek"
          position="Owner / SEO specialist"
        />
        <TeamMember
          imageUrl="images/team/avatars/tomek-kub.jpg"
          name="Tomek"
          position="Owner / Full stack developer"
        />
      </StyledGrid>
    </StyledGridContainer>
  </StyledTeam>
)

export default Team
